import { gql } from "@apollo/client";

const userFields = gql`
  fragment userFields on Me {
    id
    settings
    name
    email
    designation {
      paneltype
    }
    pagesData
    pages
    commentPages
    chatbotBots

    switchaccountsettings
    onlineStatus
    mainSuperAdminId
    picture
    pseudonym
    number
    username
    status
    stripe_id
    plans
    hasTrial
    endDate
    verified
    facebookId
    googleId
    instagramId
    subscriptionId
    currentCount
    maxCount
    currentDeletedCount
    stripe_subscription_status
    new_plan
    new_plan_status
    plan_change_effective_date
    plan_change_type
    chatbotlimit
    customFeatures
  }
`;

export default userFields;
